
export const MAJOR = "major";
export const MINOR = "minor";
export const DOMINANT = "dominant";
export const HALF_DIMINISHED = "halfDiminished";
export const MINOR_MAJOR = "minorMajor";
export const AUGMENTED_MAJOR = "augmentedMajor";
export const DIMINISHED = "diminished";
